import { RQ } from 'utils';

export default {
  getList: async function (page) {
    const { materialType = 1 } = this.$route.query;
    const { enterprise } = this;
    const res = await RQ.mall.get('/api/h5/material/getMaterialList',
      { page, pageSize: 20, materialType, enterpriseNo: enterprise },
      {jsonBody: true, enterprise: '', loading: false});
    if (res.code === 0) {
      if (page === 1) {
        this.articleList = res;
      } else {
        const pageData = this.articleList.data.pageData.concat(res.data.pageData);
        const data = Object.assign({}, res.data, {pageData})
        this.articleList = Object.assign({}, res, {data});
      }
    }
    this.isLoading = false;
    return res;
    // const res = await RQ.mall.get('/api/h5/video/listVideo', { page, pageSize: 20, couponType: 1, roleType: 1 });
    // return res;
    // return new Promise((resolve, reject) => {
    //   setTimeout(function () {
    //     resolve({
    //       code: 0,
    //       data: {
    //         pageData: new Array(20).fill({
    //           title: 'goods',
    //           path: `/pages/goods/index?goodsId=28176&groupGiftId=undefined&from=webview&isShowMenu=true`,
    //           goodsId: 28176,
    //           groupGiftId: undefined
    //         }),
    //         page: 1,
    //         pageSize: 20,
    //         total: 40
    //       },
    //       msg: 'success'
    //     });
    //   }, 1000);
    // })
  },
  onChangedList (data) {
    this.list = data;
  },
  handleToArticle (item) {
    console.log('跳转到文章');
    this.$router.push({
      path: `/wp/app/article/${item.materialId}`,
      query: {
        ...item
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/module/app/articleList/action.js